import { RequestsProvider } from 'Context';
import { FileUpload } from '../FileUpload';
import { CustomMetaTitle } from 'Components';
import { useDictionary } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { ISubCategory } from 'API/UniversalRequest/universalRequest';

interface IUploadFiles {
  parentId: number | null;
  subId: number;
  clearSubCategory: () => void;
  handleSuccess: () => void;
  resetRequest: () => void;
  titleLabel: string;
  onlineFormLink?: string;
  onlineFormLinkPrefixText?: string;
  onlineFormLinkText?: string;
  isDownload?: boolean;
  isOtp: boolean;
  subCategory?: ISubCategory;
}

export const UploadFiles = ({
  parentId,
  subId,
  clearSubCategory,
  handleSuccess,
  resetRequest,
  titleLabel,
  onlineFormLink,
  onlineFormLinkPrefixText,
  onlineFormLinkText,
  isDownload,
  isOtp,
  subCategory,
}: IUploadFiles) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);

  return (
    <>
      <CustomMetaTitle
        title={`${dictionary.title} ${dictionary.subject} ${titleLabel} - ${dictionary.metaTitleStepThree}`}
        disablePrefix
      />
      <RequestsProvider>
        <FileUpload
          parentId={parentId}
          subId={subId}
          goBack={clearSubCategory}
          handleSuccess={handleSuccess}
          resetRequest={resetRequest}
          titleLabel={titleLabel}
          onlineFormLink={onlineFormLink}
          onlineFormLinkPrefixText={onlineFormLinkPrefixText}
          onlineFormLinkText={onlineFormLinkText}
          isDownload={isDownload}
          isOtp={isOtp}
          subCategory={subCategory}
        />
      </RequestsProvider>
    </>
  );
};
